"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WalletValueTypeHandler = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
class WalletValueTypeHandler {
  constructor() {
    (0, _defineProperty2.default)(this, "type", "wallet");
  }
  value(val) {
    var _val$value;
    return (_val$value = val.value) === null || _val$value === void 0 ? void 0 : _val$value.address;
  }
  truthy(val) {
    var _val$value2;
    return !!((_val$value2 = val.value) !== null && _val$value2 !== void 0 && _val$value2.address);
  }
  address(val) {
    var _val$value3;
    return (_val$value3 = val.value) === null || _val$value3 === void 0 ? void 0 : _val$value3.address;
  }
  stringValue(val) {
    var _val$value4;
    return (_val$value4 = val.value) === null || _val$value4 === void 0 ? void 0 : _val$value4.address;
  }
}
exports.WalletValueTypeHandler = WalletValueTypeHandler;
//# sourceMappingURL=WalletValueTypeHandler.js.map